import * as React from "react";
import { Biller, Category } from "./billerCategoryTypes";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CategoriesNestedContainer from "./CategoriesNestedContainer";

type Props = {
  biller: Biller;
  onClose: Function;
  setBillerCategory?: any;
  data?: any;
};

type State = {
  loading: boolean;
  selectedCategory: Category | null;
};

class SelectCategoryModal extends React.Component<Props, State> {
  state = { loading: false, selectedCategory: null };

  didSelectCategory = (category: Category) => {
    this.setState({ selectedCategory: category });
  };

  onEdit = () => {
    this.setState({ loading: true });
    this.props
      .setBillerCategory({
        variables: {
          id: this.props.biller.id,
          category_reference: this.state.selectedCategory.external_reference
        }
      })
      .then(() => this.props.onClose({ refetchData: true }))
      .catch(alert)
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    return (
      <Dialog
        open={this.props.biller != null}
        onClose={() => this.props.onClose()}
      >
        <DialogTitle>
          <DialogContentText>Edit Biller Category:</DialogContentText>
          {!!this.state.selectedCategory ? (
            <DialogContentText>
              Setting to:{this.state.selectedCategory.name}
            </DialogContentText>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <CategoriesNestedContainer
            onSelect={this.didSelectCategory}
            categories={this.props.data.categories}
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.props.onClose()}>
            Cancel
          </Button>
          <Button
            disabled={this.state.loading || !this.state.selectedCategory}
            color="primary"
            onClick={this.onEdit}
          >
            {this.state.loading ? "Editing..." : "Edit"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const setBillerCategory = graphql<Props, any, any>(
  gql`
    mutation setBillerCategory($id: ID!, $category_reference: ID!) {
      edit_biller_category(id: $id, category_reference: $category_reference) {
        id
      }
    }
  `,
  { name: "setBillerCategory" }
);

const topCategoriesQuery = graphql<any, Props>(
  gql`
    query topCategoriesQuery {
      categories(top_level: true, offset: 0, limit: 100) {
        id
        external_reference
        icon
        updated_at
        name
        sub_categories {
          id
          external_reference
          icon
          updated_at
          name
          sub_categories {
            id
            external_reference
            icon
            updated_at
            name
          }
        }
      }
    }
  `
);

export default compose<any>(
  topCategoriesQuery,
  setBillerCategory
)(SelectCategoryModal);
